import { render, staticRenderFns } from "./CarouselOffers3d.vue?vue&type=template&id=3b3bb2ca&scoped=true&"
import script from "./CarouselOffers3d.vue?vue&type=script&lang=js&"
export * from "./CarouselOffers3d.vue?vue&type=script&lang=js&"
import style0 from "./CarouselOffers3d.vue?vue&type=style&index=0&id=3b3bb2ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3bb2ca",
  null
  
)

export default component.exports